export default "/moo2CRV.26e9dde1ba1cde968723d80488be679b.png";